import React from "react"
import { connect } from "react-redux"
import _ from "../../utils/lodashUtils"
import "./CartPopup.scss"
import { Tabs, Modal } from "antd"
import {
  NOTIFICATION_TYPES,
  ToastMessage,
  ToastMessageDestroy,
} from "../Notification/Notifications"
import {
  removeItemFromCart,
  toggleAddToCartItem,
  whichItemAreSuggested,
  saveSuggestionEvent,
  saveInstructionsToItem,
} from "../../redux/actionCreators/planDinnner"
import {
  FIREBASE_STATE_KEYS,
  FirebaseContext,
  FirebaseService,
} from "../../firebase"
import { SUGGESTION_STATES, CUSTOM_EVENTS } from "../../constants/commons"
import {
  consolidateItemQuantityInCart,
  getPartnerNameorNickName,
} from "../../utils/helpers"
import delivery_com_img from "../../assets/images/deliveryTextIcon.png"
import {
  SUGGESTED_YOU,
  YOUR_ORDER,
  READY_STATUS,
  PARTNER_SUGGESTION,
  PARTNER_ORDERS,
  ORDER_DETAILS,
  SAME_ADDRESS_ORDER_DETAILS,
  READY_FOR_CHECKOUT,
  POWERED_BY,
  YOUR_TOTAL,
  PARTNER_TOTAL,
} from "../../constants/messages"
import { useChange } from "common-custom-hooks"
import {
  ItemRow,
  SuggestedItemRow,
  EmptyCartHandler,
  CheckoutButton,
} from "./SubComponents"
import { addSelectedItemOptions } from "../../redux/actionCreators/planDinnner"
import ViewTotal from "./ViewTotal"
import closeIcon from "../../assets/images/closeicon.svg"
import { emitter } from "../../utils/emitter"
import { CART_PARTNER_NAME_ELIPSIS_LENGTH } from  "../PhoneInput/constants"

const { TabPane } = Tabs

const mapStateToProps = state => {
  return {
    user: _.get(state, "auth.user", {}),
    partner: _.get(state, "auth.partner", {}),
    total: _.get(state, "planDinner.deliveryDotComCart.total"),
    addingRemovingItemFromCart: _.get(
      state,
      "loadingState.itemOperationLoading"
    ),
    minimumOrder: _.get(
      state,
      "planDinner.deliveryDotComCart.minimum_remaining"
    ),
    showAddToCartPopup: state.planDinner.showAddToCartPopup,
    updateCartPopup: state.planDinner.isUpdate,
    selectedItemOptions: _.get(state, "planDinner.selectedItemOptions"),
  }
}

// Whole view of cart/Your plates
export const CartView = connect(mapStateToProps, {
  removeItemFromCart,
  whichItemAreSuggested,
  toggleAddToCartItem,
  saveSuggestionEvent,
  addSelectedItemOptions,
  saveInstructionsToItem,
})(props => {
  const {
    onClose,
    visible,
    partner,
    removeItemFromCart,
    toggleAddToCartItem,
    onReadyToCheckout,
    minimumOrder,
    partnerAway,
    toggleUnreadIndicator,
    saveSuggestionEvent,
    saveInstructionsToItem,
    addingRemovingItemFromCart,
  } = props

  const user = _.get(props, "user", {})

  const { userState, partnerState, dateState } = React.useContext(
    FirebaseContext
  )
  const username = _.get(userState, "userDetails.display_name", "Me")
  const partnerName = getPartnerNameorNickName(partnerState, partner)
  const isOrderCombined = _.get(
    dateState,
    FIREBASE_STATE_KEYS.IS_ORDER_COMBINED
  )
  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )
  const acceptedRestaurantMenu = _.get(acceptedRestaurant, "menus", {})
  const suggestedMenuItems = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER,
    {}
  )
  const mySuggestions = _.get(
    userState,
    FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER,
    {}
  )
  const partnerCart = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.DELIVERY_COM_CART,
    {}
  )
  const cartNotifications = _.get(
    userState,
    FIREBASE_STATE_KEYS.CART_NOTIFICATION,
    {}
  )

  const hasPendingSuggestions = !_.isEmpty(
    Object.values(suggestedMenuItems).filter(
      item =>
        item[FIREBASE_STATE_KEYS.SUGGESTION_STATE] === SUGGESTION_STATES.PENDING
    )
  )

  //open the cart when clicked on toast message of suggested item
  const openCart = () => {
    props.openCart()
    props.cartRef.current.scrollIntoView({ behavior: "smooth" })
    ToastMessageDestroy()
  }

  // fire a notification message whenever new cart notifications are recieved.
  const fireNotifications = (previousNotifications, newNotifications) => {
    let hasNewNotifications = false
    if (!_.isEmpty(newNotifications)) {
      hasNewNotifications = true
      // toggleUnreadIndicator(newNotifications[FIREBASE_STATE_KEYS.INDICATOR])
      ToastMessage({
        type: NOTIFICATION_TYPES.INFO,
        message: newNotifications[FIREBASE_STATE_KEYS.MESSAGE],
        clickedFunction: newNotifications[
          [FIREBASE_STATE_KEYS.SHOULD_OPEN_CART]
        ]
          ? () => openCart
          : null,
      })
      const path = `${FirebaseService.getDefaultPath()}${user.uuid}/${
        FIREBASE_STATE_KEYS.CART_NOTIFICATION
      }`
      FirebaseService.write(null, path)
    }
    // TODO: Check if this code is required or not.
    // if (!hasPendingSuggestions) {
    //   // only mark the notifications seen when the user has no pending suggestions left,
    //   const path = `${FirebaseService.getDefaultPath()}${user.uuid}/${
    //     FIREBASE_STATE_KEYS.CART_NOTIFICATION
    //   }`
    //   FirebaseService.write(null, path)
    // }
    toggleUnreadIndicator(hasPendingSuggestions || hasNewNotifications)
  }

  useChange(cartNotifications, fireNotifications, _.isEqual)

  const partnerTotal =
    _.get(partnerCart, "subtotal") + _.get(partnerCart, "tax")
  const myCart = _.get(userState, FIREBASE_STATE_KEYS.DELIVERY_COM_CART, {})
  const combinedTotal =
    _.get(myCart, "subtotal", 0) + _.get(partnerCart, "subtotal", 0)
  const isMinimumRemaining = isOrderCombined
    ? minimumOrder - partnerTotal > 0
    : minimumOrder > 0 || myCart.subtotal === 0
  const min_order_text = isOrderCombined
    ? SAME_ADDRESS_ORDER_DETAILS
    : ORDER_DETAILS

  const myCartItems = consolidateItemQuantityInCart(myCart.cart)
  const partnerCartItems = consolidateItemQuantityInCart(partnerCart.cart)
  const deliveryMinimum = _.get(
    acceptedRestaurant,
    `${FIREBASE_STATE_KEYS.DELIVERY_MINIMUM}`,
    ""
  )

  const partnerReadyForCheckout = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT,
    false
  )
  const userReadyForCheckout = _.get(
    userState,
    FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT,
    false
  )

  const wasIReadyForCheckoutFirst =
    _.get(dateState, FIREBASE_STATE_KEYS.FIRST_USER_READY_FOR_CHECKOUT, ``) ===
    _.get(user, "uuid")

  React.useEffect(() => {
    if (isMinimumRemaining) {
      FirebaseService.delete(
        `${FirebaseService.getDefaultPath()}${user.uuid}/${
          FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT
        }`
      )
    }
    if (partnerReadyForCheckout && userReadyForCheckout) {
      // partner is ready for checkout along with user, navigate to checkout screen.
      // if I am the first user who got ready for checkout, i.e I was waiting for other partner to be ready.
      // show a modal telling, my wait is over and partner is ready as well.
      if (wasIReadyForCheckoutFirst) {
        Modal.destroyAll()
        emitter.fire(CUSTOM_EVENTS.SHOW_READY_FOR_CHECKOUT_MODAL, [])
      } else {
        if (!isMinimumRemaining) {
          Modal.destroyAll()
          onReadyToCheckout()
        }
      }
    }
  }, [
    partnerReadyForCheckout,
    userReadyForCheckout,
    wasIReadyForCheckoutFirst,
    isMinimumRemaining,
  ])

  const hasSuggested = !_.isEmpty(Object.values(mySuggestions))

  const userTabHeader = () => {
    if (hasPendingSuggestions) {
      return (
        <section className="ready-tab-header">
          <span>{YOUR_ORDER}</span>
          <span className="tab-unread-indicator"></span>
        </section>
      )
    }
    return YOUR_ORDER
  }
  const addElipsisEfect = (input) => input.length > CART_PARTNER_NAME_ELIPSIS_LENGTH ? `${input.substring(0, CART_PARTNER_NAME_ELIPSIS_LENGTH)}...` : input; 
  const partnerTabHeader = () => {
    if (partnerReadyForCheckout) {
      return (
        <section className="ready-tab-header">
          <span>{addElipsisEfect(partnerName)}</span>
          <div className="ready-status">{READY_STATUS}</div>
        </section>
      )
    }
    return addElipsisEfect(partnerName)
  }

  const onClickReadyForCheckout = async () => {
    let firebaseUpdateData = {}
    if (!partnerReadyForCheckout) {
      firebaseUpdateData[
        `${FIREBASE_STATE_KEYS.FIRST_USER_READY_FOR_CHECKOUT}`
      ] = user.uuid
    }
    firebaseUpdateData[
      `${partner.uuid}/${FIREBASE_STATE_KEYS.CART_NOTIFICATION}`
    ] = {
      [FIREBASE_STATE_KEYS.INDICATOR]: true,
      [FIREBASE_STATE_KEYS.MESSAGE]: READY_FOR_CHECKOUT(
        _.get(user, "display_name", "")
      ),
      [FIREBASE_STATE_KEYS.TIMESTAMP]: Date.now(),
    }
    firebaseUpdateData[
      `${user.uuid}/${FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT}`
    ] = true
    await FirebaseService.patch(
      firebaseUpdateData,
      FirebaseService.getDefaultPath()
    )
  }

  const onClickNotReadyForCheckout = async () => {
    await FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.FIRST_USER_READY_FOR_CHECKOUT]: null,
        [`${user.uuid}/${FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT}`]: false,
      },
      FirebaseService.getDefaultPath()
    )
  }

  const onAddItemToCart = item => () => {
    //get the item object from the whole restaurant menu
    let itemPayload = {}
    Object.values(acceptedRestaurantMenu).forEach(partialMenu => {
      partialMenu.children &&
        partialMenu.children.forEach(menuItem => {
          if (menuItem.id === item.id) {
            itemPayload = menuItem
            return
          }
        })
    })
    !_.isEmpty(itemPayload) && toggleAddToCartItem(true, itemPayload)
  }

  const myPrice = myCart.subtotal ? myCart.subtotal.toFixed(2) : "0.00"
  const partnerPrice = partnerCart.subtotal
    ? partnerCart.subtotal.toFixed(2)
    : "0.00"
  const pendingCartRequest = item =>
    addingRemovingItemFromCart && item.id === addingRemovingItemFromCart.item_id

  return visible ? (
    <section className="cart-window">
      <div class="view-header">
        <div class="arrow-up"></div>
        <img src={closeIcon} className="close-btn" onClick={onClose} />
      </div>
      <section className="view-body">
        <Tabs defaultActiveKey="1" className="cart-tabs-wrapper">
          <TabPane tab={userTabHeader()} key="1">
            <section
              className={`tab-view-container ${
                myPrice == "0.00" && !hasPendingSuggestions ? "tab-center" : ""
              }`}
            >
              {hasPendingSuggestions && (
                <section className="suggested-items">
                  <label className="label">
                    <span class="partner-name"> {partnerName} </span>{" "}
                    {SUGGESTED_YOU}
                  </label>
                  <ol className="items-list">
                    {!_.isEmpty(suggestedMenuItems) &&
                      Object.values(
                        suggestedMenuItems
                      ).map((suggestion, index) => (
                        <SuggestedItemRow
                          {...suggestion}
                          key={index}
                          onAddItemToCart={onAddItemToCart(suggestion.item)}
                          partner={partner}
                          user={user}
                          saveSuggestionEvent={saveSuggestionEvent}
                        />
                      ))}
                  </ol>
                </section>
              )}
              <section className="my-cart-items">
                <EmptyCartHandler items={myCartItems}>
                  <label className="label">{YOUR_ORDER}</label>
                  <ol className="items-list">
                    {myCartItems &&
                      myCartItems.map((item, index) => (
                        <ItemRow
                          {...props}
                          key={index}
                          item={item}
                          mySuggestions={mySuggestions}
                          removeItemFromCart={removeItemFromCart}
                          onAddToMyCart={onAddItemToCart(item)}
                          itemLoading={pendingCartRequest(item)}
                          partnerAway={partnerAway}
                          partnerCart={partnerCart}
                          isMyItem={true}
                          saveInstructionsToItem={saveInstructionsToItem}
                        />
                      ))}
                  </ol>
                </EmptyCartHandler>
              </section>
            </section>
            <ViewTotal name={YOUR_TOTAL} price={myPrice} />
          </TabPane>
          <TabPane tab={partnerTabHeader()} key="2">
            <section
              className={`tab-view-container ${
                partnerPrice == "0.00" && !hasSuggested ? "tab-center" : ""
              }`}
            >
              {partnerReadyForCheckout && (
                <p className="partner-ready-info">{`${partnerName} is ready to checkout!`}</p>
              )}
              {hasSuggested && (
                <section className="suggested-items">
                  <label className="label">
                    {PARTNER_SUGGESTION(partnerName)}
                  </label>
                  <ol className="items-list">
                    {!_.isEmpty(mySuggestions) &&
                      Object.values(mySuggestions).map((suggestion, index) => (
                        <SuggestedItemRow
                          {...suggestion}
                          isPartner
                          key={index}
                          partner={partner}
                          saveSuggestionEvent={saveSuggestionEvent}
                        />
                      ))}
                  </ol>
                </section>
              )}
              <section className="my-cart-items">
                <EmptyCartHandler items={partnerCartItems}>
                  <label className="label">
                    {PARTNER_ORDERS(_.get(partner, "display_name", "Partner"))}
                  </label>
                  <ol className="items-list">
                    {partnerCartItems &&
                      partnerCartItems.map((item, index) => (
                        <ItemRow
                          key={index}
                          item={item}
                          isPartner
                          onAddToMyCart={onAddItemToCart(item)}
                          user={user}
                          itemLoading={pendingCartRequest(item)}
                          props={props}
                          partner={partner}
                          isMyItem={false}
                        />
                      ))}
                  </ol>
                </EmptyCartHandler>
              </section>
            </section>
            <ViewTotal name={PARTNER_TOTAL(partnerName)} price={partnerPrice} />
          </TabPane>
        </Tabs>
      </section>
      <section className="view-footer">
        <CheckoutButton
          userReadyForCheckout={userReadyForCheckout}
          partnerName={partnerName}
          onClickReadyForCheckout={onClickReadyForCheckout}
          isMinimumRemaining={isMinimumRemaining}
          onNotReadyForCheckout={onClickNotReadyForCheckout}
          deliveryMinimum={deliveryMinimum}
          min_order_text={min_order_text}
        />
        <div className="powered-by">
          {POWERED_BY} <img src={delivery_com_img} alt="delivery.com" />
        </div>
      </section>
    </section>
  ) : null
})
